<template>
  <ElSelect
    :value="value"
    :placeholder="$t('ADVERTISEMENT.BID.MATCH_TYPE')"
    @input="emitValue"
  >
    <ElOption
      v-for="matchType in matchingTypes"
      :key="matchType.property"
      :label="matchType.label"
      :value="matchType.property"
    />
  </ElSelect>
</template>

<script>
import { matchingTypes } from '../constants';

export default {
  name: 'MatchingTypeSelect',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    matchingTypes() {
      return matchingTypes;
    },
  },
  methods: {
    emitValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>
